// You can write more code here

/* START OF COMPILED CODE */

import TransitionBase from "../core/derived-classes/TransitionBase";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TransitionPrefab extends TransitionBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 936.5, y ?? 400);

    // rectangle_1
    const rectangle_1 = scene.add.rectangle(23, -14, 1920, 768);
    rectangle_1.scaleX = 1.0441224934966145;
    rectangle_1.scaleY = 1.0717752999848922;
    rectangle_1.isFilled = true;
    rectangle_1.fillColor = 344227;
    this.add(rectangle_1);

    // group8
    const group8 = scene.add.container(22, -20);
    this.add(group8);

    // icon_passenger_1_png_7
    const icon_passenger_1_png_7 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_7.scaleX = 0.35;
    icon_passenger_1_png_7.scaleY = 0.35;
    group8.add(icon_passenger_1_png_7);

    // icon_passenger_10_png_7
    const icon_passenger_10_png_7 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_7.scaleX = 0.35;
    icon_passenger_10_png_7.scaleY = 0.35;
    group8.add(icon_passenger_10_png_7);

    // icon_passenger_11_png_7
    const icon_passenger_11_png_7 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_7.scaleX = 0.35;
    icon_passenger_11_png_7.scaleY = 0.35;
    group8.add(icon_passenger_11_png_7);

    // icon_passenger_12_png_7
    const icon_passenger_12_png_7 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_7.scaleX = 0.35;
    icon_passenger_12_png_7.scaleY = 0.35;
    group8.add(icon_passenger_12_png_7);

    // icon_passenger_13_png_7
    const icon_passenger_13_png_7 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_7.scaleX = 0.35;
    icon_passenger_13_png_7.scaleY = 0.35;
    group8.add(icon_passenger_13_png_7);

    // icon_passenger_14_png_7
    const icon_passenger_14_png_7 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_7.scaleX = 0.35;
    icon_passenger_14_png_7.scaleY = 0.35;
    group8.add(icon_passenger_14_png_7);

    // icon_passenger_15_png_7
    const icon_passenger_15_png_7 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_7.scaleX = 0.35;
    icon_passenger_15_png_7.scaleY = 0.35;
    group8.add(icon_passenger_15_png_7);

    // icon_passenger_16_png_7
    const icon_passenger_16_png_7 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_7.scaleX = 0.35;
    icon_passenger_16_png_7.scaleY = 0.35;
    group8.add(icon_passenger_16_png_7);

    // icon_passenger_17_png_7
    const icon_passenger_17_png_7 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_7.scaleX = 0.35;
    icon_passenger_17_png_7.scaleY = 0.35;
    group8.add(icon_passenger_17_png_7);

    // icon_passenger_18_png_7
    const icon_passenger_18_png_7 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_7.scaleX = 0.35;
    icon_passenger_18_png_7.scaleY = 0.35;
    group8.add(icon_passenger_18_png_7);

    // icon_passenger_19_png_7
    const icon_passenger_19_png_7 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_7.scaleX = 0.35;
    icon_passenger_19_png_7.scaleY = 0.35;
    group8.add(icon_passenger_19_png_7);

    // icon_passenger_2_png_7
    const icon_passenger_2_png_7 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_7.scaleX = 0.35;
    icon_passenger_2_png_7.scaleY = 0.35;
    group8.add(icon_passenger_2_png_7);

    // icon_passenger_20_png_7
    const icon_passenger_20_png_7 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_7.scaleX = 0.35;
    icon_passenger_20_png_7.scaleY = 0.35;
    group8.add(icon_passenger_20_png_7);

    // icon_passenger_3_png_7
    const icon_passenger_3_png_7 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_7.scaleX = 0.35;
    icon_passenger_3_png_7.scaleY = 0.35;
    group8.add(icon_passenger_3_png_7);

    // icon_passenger_4_png_7
    const icon_passenger_4_png_7 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_7.scaleX = 0.35;
    icon_passenger_4_png_7.scaleY = 0.35;
    group8.add(icon_passenger_4_png_7);

    // icon_passenger_5_png_7
    const icon_passenger_5_png_7 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_7.scaleX = 0.35;
    icon_passenger_5_png_7.scaleY = 0.35;
    group8.add(icon_passenger_5_png_7);

    // icon_passenger_6_png_7
    const icon_passenger_6_png_7 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_7.scaleX = 0.35;
    icon_passenger_6_png_7.scaleY = 0.35;
    group8.add(icon_passenger_6_png_7);

    // icon_passenger_7_png_7
    const icon_passenger_7_png_7 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_7.scaleX = 0.35;
    icon_passenger_7_png_7.scaleY = 0.35;
    group8.add(icon_passenger_7_png_7);

    // icon_passenger_8_png_7
    const icon_passenger_8_png_7 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_7.scaleX = 0.35;
    icon_passenger_8_png_7.scaleY = 0.35;
    group8.add(icon_passenger_8_png_7);

    // icon_passenger_9_png_7
    const icon_passenger_9_png_7 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_7.scaleX = 0.35;
    icon_passenger_9_png_7.scaleY = 0.35;
    group8.add(icon_passenger_9_png_7);

    // group7
    const group7 = scene.add.container(602, -20);
    this.add(group7);

    // icon_passenger_1_png_6
    const icon_passenger_1_png_6 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_6.scaleX = 0.35;
    icon_passenger_1_png_6.scaleY = 0.35;
    group7.add(icon_passenger_1_png_6);

    // icon_passenger_10_png_6
    const icon_passenger_10_png_6 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_6.scaleX = 0.35;
    icon_passenger_10_png_6.scaleY = 0.35;
    group7.add(icon_passenger_10_png_6);

    // icon_passenger_11_png_6
    const icon_passenger_11_png_6 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_6.scaleX = 0.35;
    icon_passenger_11_png_6.scaleY = 0.35;
    group7.add(icon_passenger_11_png_6);

    // icon_passenger_12_png_6
    const icon_passenger_12_png_6 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_6.scaleX = 0.35;
    icon_passenger_12_png_6.scaleY = 0.35;
    group7.add(icon_passenger_12_png_6);

    // icon_passenger_13_png_6
    const icon_passenger_13_png_6 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_6.scaleX = 0.35;
    icon_passenger_13_png_6.scaleY = 0.35;
    group7.add(icon_passenger_13_png_6);

    // icon_passenger_14_png_6
    const icon_passenger_14_png_6 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_6.scaleX = 0.35;
    icon_passenger_14_png_6.scaleY = 0.35;
    group7.add(icon_passenger_14_png_6);

    // icon_passenger_15_png_6
    const icon_passenger_15_png_6 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_6.scaleX = 0.35;
    icon_passenger_15_png_6.scaleY = 0.35;
    group7.add(icon_passenger_15_png_6);

    // icon_passenger_16_png_6
    const icon_passenger_16_png_6 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_6.scaleX = 0.35;
    icon_passenger_16_png_6.scaleY = 0.35;
    group7.add(icon_passenger_16_png_6);

    // icon_passenger_17_png_6
    const icon_passenger_17_png_6 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_6.scaleX = 0.35;
    icon_passenger_17_png_6.scaleY = 0.35;
    group7.add(icon_passenger_17_png_6);

    // icon_passenger_18_png_6
    const icon_passenger_18_png_6 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_6.scaleX = 0.35;
    icon_passenger_18_png_6.scaleY = 0.35;
    group7.add(icon_passenger_18_png_6);

    // icon_passenger_19_png_6
    const icon_passenger_19_png_6 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_6.scaleX = 0.35;
    icon_passenger_19_png_6.scaleY = 0.35;
    group7.add(icon_passenger_19_png_6);

    // icon_passenger_2_png_6
    const icon_passenger_2_png_6 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_6.scaleX = 0.35;
    icon_passenger_2_png_6.scaleY = 0.35;
    group7.add(icon_passenger_2_png_6);

    // icon_passenger_20_png_6
    const icon_passenger_20_png_6 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_6.scaleX = 0.35;
    icon_passenger_20_png_6.scaleY = 0.35;
    group7.add(icon_passenger_20_png_6);

    // icon_passenger_3_png_6
    const icon_passenger_3_png_6 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_6.scaleX = 0.35;
    icon_passenger_3_png_6.scaleY = 0.35;
    group7.add(icon_passenger_3_png_6);

    // icon_passenger_4_png_6
    const icon_passenger_4_png_6 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_6.scaleX = 0.35;
    icon_passenger_4_png_6.scaleY = 0.35;
    group7.add(icon_passenger_4_png_6);

    // icon_passenger_5_png_6
    const icon_passenger_5_png_6 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_6.scaleX = 0.35;
    icon_passenger_5_png_6.scaleY = 0.35;
    group7.add(icon_passenger_5_png_6);

    // icon_passenger_6_png_6
    const icon_passenger_6_png_6 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_6.scaleX = 0.35;
    icon_passenger_6_png_6.scaleY = 0.35;
    group7.add(icon_passenger_6_png_6);

    // icon_passenger_7_png_6
    const icon_passenger_7_png_6 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_6.scaleX = 0.35;
    icon_passenger_7_png_6.scaleY = 0.35;
    group7.add(icon_passenger_7_png_6);

    // icon_passenger_8_png_6
    const icon_passenger_8_png_6 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_6.scaleX = 0.35;
    icon_passenger_8_png_6.scaleY = 0.35;
    group7.add(icon_passenger_8_png_6);

    // icon_passenger_9_png_6
    const icon_passenger_9_png_6 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_6.scaleX = 0.35;
    icon_passenger_9_png_6.scaleY = 0.35;
    group7.add(icon_passenger_9_png_6);

    // group6
    const group6 = scene.add.container(-558, -20);
    this.add(group6);

    // icon_passenger_1_png_2
    const icon_passenger_1_png_2 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_2.scaleX = 0.35;
    icon_passenger_1_png_2.scaleY = 0.35;
    group6.add(icon_passenger_1_png_2);

    // icon_passenger_10_png_2
    const icon_passenger_10_png_2 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_2.scaleX = 0.35;
    icon_passenger_10_png_2.scaleY = 0.35;
    group6.add(icon_passenger_10_png_2);

    // icon_passenger_11_png_2
    const icon_passenger_11_png_2 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_2.scaleX = 0.35;
    icon_passenger_11_png_2.scaleY = 0.35;
    group6.add(icon_passenger_11_png_2);

    // icon_passenger_12_png_2
    const icon_passenger_12_png_2 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_2.scaleX = 0.35;
    icon_passenger_12_png_2.scaleY = 0.35;
    group6.add(icon_passenger_12_png_2);

    // icon_passenger_13_png_2
    const icon_passenger_13_png_2 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_2.scaleX = 0.35;
    icon_passenger_13_png_2.scaleY = 0.35;
    group6.add(icon_passenger_13_png_2);

    // icon_passenger_14_png_2
    const icon_passenger_14_png_2 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_2.scaleX = 0.35;
    icon_passenger_14_png_2.scaleY = 0.35;
    group6.add(icon_passenger_14_png_2);

    // icon_passenger_15_png_2
    const icon_passenger_15_png_2 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_2.scaleX = 0.35;
    icon_passenger_15_png_2.scaleY = 0.35;
    group6.add(icon_passenger_15_png_2);

    // icon_passenger_16_png_2
    const icon_passenger_16_png_2 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_2.scaleX = 0.35;
    icon_passenger_16_png_2.scaleY = 0.35;
    group6.add(icon_passenger_16_png_2);

    // icon_passenger_17_png_2
    const icon_passenger_17_png_2 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_2.scaleX = 0.35;
    icon_passenger_17_png_2.scaleY = 0.35;
    group6.add(icon_passenger_17_png_2);

    // icon_passenger_18_png_2
    const icon_passenger_18_png_2 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_2.scaleX = 0.35;
    icon_passenger_18_png_2.scaleY = 0.35;
    group6.add(icon_passenger_18_png_2);

    // icon_passenger_19_png_2
    const icon_passenger_19_png_2 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_2.scaleX = 0.35;
    icon_passenger_19_png_2.scaleY = 0.35;
    group6.add(icon_passenger_19_png_2);

    // icon_passenger_2_png_2
    const icon_passenger_2_png_2 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_2.scaleX = 0.35;
    icon_passenger_2_png_2.scaleY = 0.35;
    group6.add(icon_passenger_2_png_2);

    // icon_passenger_20_png_2
    const icon_passenger_20_png_2 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_2.scaleX = 0.35;
    icon_passenger_20_png_2.scaleY = 0.35;
    group6.add(icon_passenger_20_png_2);

    // icon_passenger_3_png_2
    const icon_passenger_3_png_2 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_2.scaleX = 0.35;
    icon_passenger_3_png_2.scaleY = 0.35;
    group6.add(icon_passenger_3_png_2);

    // icon_passenger_4_png_2
    const icon_passenger_4_png_2 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_2.scaleX = 0.35;
    icon_passenger_4_png_2.scaleY = 0.35;
    group6.add(icon_passenger_4_png_2);

    // icon_passenger_5_png_2
    const icon_passenger_5_png_2 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_2.scaleX = 0.35;
    icon_passenger_5_png_2.scaleY = 0.35;
    group6.add(icon_passenger_5_png_2);

    // icon_passenger_6_png_2
    const icon_passenger_6_png_2 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_2.scaleX = 0.35;
    icon_passenger_6_png_2.scaleY = 0.35;
    group6.add(icon_passenger_6_png_2);

    // icon_passenger_7_png_2
    const icon_passenger_7_png_2 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_2.scaleX = 0.35;
    icon_passenger_7_png_2.scaleY = 0.35;
    group6.add(icon_passenger_7_png_2);

    // icon_passenger_8_png_2
    const icon_passenger_8_png_2 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_2.scaleX = 0.35;
    icon_passenger_8_png_2.scaleY = 0.35;
    group6.add(icon_passenger_8_png_2);

    // icon_passenger_9_png_2
    const icon_passenger_9_png_2 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_2.scaleX = 0.35;
    icon_passenger_9_png_2.scaleY = 0.35;
    group6.add(icon_passenger_9_png_2);

    // group5
    const group5 = scene.add.container(-1138, -20);
    this.add(group5);

    // icon_passenger_1_png_1
    const icon_passenger_1_png_1 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_1.scaleX = 0.35;
    icon_passenger_1_png_1.scaleY = 0.35;
    group5.add(icon_passenger_1_png_1);

    // icon_passenger_10_png_1
    const icon_passenger_10_png_1 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_1.scaleX = 0.35;
    icon_passenger_10_png_1.scaleY = 0.35;
    group5.add(icon_passenger_10_png_1);

    // icon_passenger_11_png_1
    const icon_passenger_11_png_1 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_1.scaleX = 0.35;
    icon_passenger_11_png_1.scaleY = 0.35;
    group5.add(icon_passenger_11_png_1);

    // icon_passenger_12_png_1
    const icon_passenger_12_png_1 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_1.scaleX = 0.35;
    icon_passenger_12_png_1.scaleY = 0.35;
    group5.add(icon_passenger_12_png_1);

    // icon_passenger_13_png_1
    const icon_passenger_13_png_1 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_1.scaleX = 0.35;
    icon_passenger_13_png_1.scaleY = 0.35;
    group5.add(icon_passenger_13_png_1);

    // icon_passenger_14_png_1
    const icon_passenger_14_png_1 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_1.scaleX = 0.35;
    icon_passenger_14_png_1.scaleY = 0.35;
    group5.add(icon_passenger_14_png_1);

    // icon_passenger_15_png_1
    const icon_passenger_15_png_1 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_1.scaleX = 0.35;
    icon_passenger_15_png_1.scaleY = 0.35;
    group5.add(icon_passenger_15_png_1);

    // icon_passenger_16_png_1
    const icon_passenger_16_png_1 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_1.scaleX = 0.35;
    icon_passenger_16_png_1.scaleY = 0.35;
    group5.add(icon_passenger_16_png_1);

    // icon_passenger_17_png_1
    const icon_passenger_17_png_1 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_1.scaleX = 0.35;
    icon_passenger_17_png_1.scaleY = 0.35;
    group5.add(icon_passenger_17_png_1);

    // icon_passenger_18_png_1
    const icon_passenger_18_png_1 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_1.scaleX = 0.35;
    icon_passenger_18_png_1.scaleY = 0.35;
    group5.add(icon_passenger_18_png_1);

    // icon_passenger_19_png_1
    const icon_passenger_19_png_1 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_1.scaleX = 0.35;
    icon_passenger_19_png_1.scaleY = 0.35;
    group5.add(icon_passenger_19_png_1);

    // icon_passenger_2_png_1
    const icon_passenger_2_png_1 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_1.scaleX = 0.35;
    icon_passenger_2_png_1.scaleY = 0.35;
    group5.add(icon_passenger_2_png_1);

    // icon_passenger_20_png_1
    const icon_passenger_20_png_1 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_1.scaleX = 0.35;
    icon_passenger_20_png_1.scaleY = 0.35;
    group5.add(icon_passenger_20_png_1);

    // icon_passenger_3_png_1
    const icon_passenger_3_png_1 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_1.scaleX = 0.35;
    icon_passenger_3_png_1.scaleY = 0.35;
    group5.add(icon_passenger_3_png_1);

    // icon_passenger_4_png_1
    const icon_passenger_4_png_1 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_1.scaleX = 0.35;
    icon_passenger_4_png_1.scaleY = 0.35;
    group5.add(icon_passenger_4_png_1);

    // icon_passenger_5_png_1
    const icon_passenger_5_png_1 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_1.scaleX = 0.35;
    icon_passenger_5_png_1.scaleY = 0.35;
    group5.add(icon_passenger_5_png_1);

    // icon_passenger_6_png_1
    const icon_passenger_6_png_1 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_1.scaleX = 0.35;
    icon_passenger_6_png_1.scaleY = 0.35;
    group5.add(icon_passenger_6_png_1);

    // icon_passenger_7_png_1
    const icon_passenger_7_png_1 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_1.scaleX = 0.35;
    icon_passenger_7_png_1.scaleY = 0.35;
    group5.add(icon_passenger_7_png_1);

    // icon_passenger_8_png_1
    const icon_passenger_8_png_1 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_1.scaleX = 0.35;
    icon_passenger_8_png_1.scaleY = 0.35;
    group5.add(icon_passenger_8_png_1);

    // icon_passenger_9_png_1
    const icon_passenger_9_png_1 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_1.scaleX = 0.35;
    icon_passenger_9_png_1.scaleY = 0.35;
    group5.add(icon_passenger_9_png_1);

    // group4
    const group4 = scene.add.container(602, -484);
    this.add(group4);

    // icon_passenger_1_png_3
    const icon_passenger_1_png_3 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_3.scaleX = 0.35;
    icon_passenger_1_png_3.scaleY = 0.35;
    group4.add(icon_passenger_1_png_3);

    // icon_passenger_10_png_3
    const icon_passenger_10_png_3 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_3.scaleX = 0.35;
    icon_passenger_10_png_3.scaleY = 0.35;
    group4.add(icon_passenger_10_png_3);

    // icon_passenger_11_png_3
    const icon_passenger_11_png_3 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_3.scaleX = 0.35;
    icon_passenger_11_png_3.scaleY = 0.35;
    group4.add(icon_passenger_11_png_3);

    // icon_passenger_12_png_3
    const icon_passenger_12_png_3 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_3.scaleX = 0.35;
    icon_passenger_12_png_3.scaleY = 0.35;
    group4.add(icon_passenger_12_png_3);

    // icon_passenger_13_png_3
    const icon_passenger_13_png_3 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_3.scaleX = 0.35;
    icon_passenger_13_png_3.scaleY = 0.35;
    group4.add(icon_passenger_13_png_3);

    // icon_passenger_14_png_3
    const icon_passenger_14_png_3 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_3.scaleX = 0.35;
    icon_passenger_14_png_3.scaleY = 0.35;
    group4.add(icon_passenger_14_png_3);

    // icon_passenger_15_png_3
    const icon_passenger_15_png_3 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_3.scaleX = 0.35;
    icon_passenger_15_png_3.scaleY = 0.35;
    group4.add(icon_passenger_15_png_3);

    // icon_passenger_16_png_3
    const icon_passenger_16_png_3 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_3.scaleX = 0.35;
    icon_passenger_16_png_3.scaleY = 0.35;
    group4.add(icon_passenger_16_png_3);

    // icon_passenger_17_png_3
    const icon_passenger_17_png_3 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_3.scaleX = 0.35;
    icon_passenger_17_png_3.scaleY = 0.35;
    group4.add(icon_passenger_17_png_3);

    // icon_passenger_18_png_3
    const icon_passenger_18_png_3 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_3.scaleX = 0.35;
    icon_passenger_18_png_3.scaleY = 0.35;
    group4.add(icon_passenger_18_png_3);

    // icon_passenger_19_png_3
    const icon_passenger_19_png_3 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_3.scaleX = 0.35;
    icon_passenger_19_png_3.scaleY = 0.35;
    group4.add(icon_passenger_19_png_3);

    // icon_passenger_2_png_3
    const icon_passenger_2_png_3 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_3.scaleX = 0.35;
    icon_passenger_2_png_3.scaleY = 0.35;
    group4.add(icon_passenger_2_png_3);

    // icon_passenger_20_png_3
    const icon_passenger_20_png_3 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_3.scaleX = 0.35;
    icon_passenger_20_png_3.scaleY = 0.35;
    group4.add(icon_passenger_20_png_3);

    // icon_passenger_3_png_3
    const icon_passenger_3_png_3 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_3.scaleX = 0.35;
    icon_passenger_3_png_3.scaleY = 0.35;
    group4.add(icon_passenger_3_png_3);

    // icon_passenger_4_png_3
    const icon_passenger_4_png_3 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_3.scaleX = 0.35;
    icon_passenger_4_png_3.scaleY = 0.35;
    group4.add(icon_passenger_4_png_3);

    // icon_passenger_5_png_3
    const icon_passenger_5_png_3 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_3.scaleX = 0.35;
    icon_passenger_5_png_3.scaleY = 0.35;
    group4.add(icon_passenger_5_png_3);

    // icon_passenger_6_png_3
    const icon_passenger_6_png_3 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_3.scaleX = 0.35;
    icon_passenger_6_png_3.scaleY = 0.35;
    group4.add(icon_passenger_6_png_3);

    // icon_passenger_7_png_3
    const icon_passenger_7_png_3 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_3.scaleX = 0.35;
    icon_passenger_7_png_3.scaleY = 0.35;
    group4.add(icon_passenger_7_png_3);

    // icon_passenger_8_png_3
    const icon_passenger_8_png_3 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_3.scaleX = 0.35;
    icon_passenger_8_png_3.scaleY = 0.35;
    group4.add(icon_passenger_8_png_3);

    // icon_passenger_9_png_3
    const icon_passenger_9_png_3 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_3.scaleX = 0.35;
    icon_passenger_9_png_3.scaleY = 0.35;
    group4.add(icon_passenger_9_png_3);

    // group3
    const group3 = scene.add.container(22, -486);
    this.add(group3);

    // icon_passenger_1_png_4
    const icon_passenger_1_png_4 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_4.scaleX = 0.35;
    icon_passenger_1_png_4.scaleY = 0.35;
    group3.add(icon_passenger_1_png_4);

    // icon_passenger_10_png_4
    const icon_passenger_10_png_4 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_4.scaleX = 0.35;
    icon_passenger_10_png_4.scaleY = 0.35;
    group3.add(icon_passenger_10_png_4);

    // icon_passenger_11_png_4
    const icon_passenger_11_png_4 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_4.scaleX = 0.35;
    icon_passenger_11_png_4.scaleY = 0.35;
    group3.add(icon_passenger_11_png_4);

    // icon_passenger_12_png_4
    const icon_passenger_12_png_4 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_4.scaleX = 0.35;
    icon_passenger_12_png_4.scaleY = 0.35;
    group3.add(icon_passenger_12_png_4);

    // icon_passenger_13_png_4
    const icon_passenger_13_png_4 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_4.scaleX = 0.35;
    icon_passenger_13_png_4.scaleY = 0.35;
    group3.add(icon_passenger_13_png_4);

    // icon_passenger_14_png_4
    const icon_passenger_14_png_4 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_4.scaleX = 0.35;
    icon_passenger_14_png_4.scaleY = 0.35;
    group3.add(icon_passenger_14_png_4);

    // icon_passenger_15_png_4
    const icon_passenger_15_png_4 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_4.scaleX = 0.35;
    icon_passenger_15_png_4.scaleY = 0.35;
    group3.add(icon_passenger_15_png_4);

    // icon_passenger_16_png_4
    const icon_passenger_16_png_4 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_4.scaleX = 0.35;
    icon_passenger_16_png_4.scaleY = 0.35;
    group3.add(icon_passenger_16_png_4);

    // icon_passenger_17_png_4
    const icon_passenger_17_png_4 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_4.scaleX = 0.35;
    icon_passenger_17_png_4.scaleY = 0.35;
    group3.add(icon_passenger_17_png_4);

    // icon_passenger_18_png_4
    const icon_passenger_18_png_4 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_4.scaleX = 0.35;
    icon_passenger_18_png_4.scaleY = 0.35;
    group3.add(icon_passenger_18_png_4);

    // icon_passenger_19_png_4
    const icon_passenger_19_png_4 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_4.scaleX = 0.35;
    icon_passenger_19_png_4.scaleY = 0.35;
    group3.add(icon_passenger_19_png_4);

    // icon_passenger_2_png_4
    const icon_passenger_2_png_4 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_4.scaleX = 0.35;
    icon_passenger_2_png_4.scaleY = 0.35;
    group3.add(icon_passenger_2_png_4);

    // icon_passenger_20_png_4
    const icon_passenger_20_png_4 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_4.scaleX = 0.35;
    icon_passenger_20_png_4.scaleY = 0.35;
    group3.add(icon_passenger_20_png_4);

    // icon_passenger_3_png_4
    const icon_passenger_3_png_4 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_4.scaleX = 0.35;
    icon_passenger_3_png_4.scaleY = 0.35;
    group3.add(icon_passenger_3_png_4);

    // icon_passenger_4_png_4
    const icon_passenger_4_png_4 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_4.scaleX = 0.35;
    icon_passenger_4_png_4.scaleY = 0.35;
    group3.add(icon_passenger_4_png_4);

    // icon_passenger_5_png_4
    const icon_passenger_5_png_4 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_4.scaleX = 0.35;
    icon_passenger_5_png_4.scaleY = 0.35;
    group3.add(icon_passenger_5_png_4);

    // icon_passenger_6_png_4
    const icon_passenger_6_png_4 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_4.scaleX = 0.35;
    icon_passenger_6_png_4.scaleY = 0.35;
    group3.add(icon_passenger_6_png_4);

    // icon_passenger_7_png_4
    const icon_passenger_7_png_4 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_4.scaleX = 0.35;
    icon_passenger_7_png_4.scaleY = 0.35;
    group3.add(icon_passenger_7_png_4);

    // icon_passenger_8_png_4
    const icon_passenger_8_png_4 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_4.scaleX = 0.35;
    icon_passenger_8_png_4.scaleY = 0.35;
    group3.add(icon_passenger_8_png_4);

    // icon_passenger_9_png_4
    const icon_passenger_9_png_4 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_4.scaleX = 0.35;
    icon_passenger_9_png_4.scaleY = 0.35;
    group3.add(icon_passenger_9_png_4);

    // group2
    const group2 = scene.add.container(-558, -484);
    this.add(group2);

    // icon_passenger_1_png
    const icon_passenger_1_png = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png.scaleX = 0.35;
    icon_passenger_1_png.scaleY = 0.35;
    group2.add(icon_passenger_1_png);

    // icon_passenger_10_png
    const icon_passenger_10_png = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png.scaleX = 0.35;
    icon_passenger_10_png.scaleY = 0.35;
    group2.add(icon_passenger_10_png);

    // icon_passenger_11_png
    const icon_passenger_11_png = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png.scaleX = 0.35;
    icon_passenger_11_png.scaleY = 0.35;
    group2.add(icon_passenger_11_png);

    // icon_passenger_12_png
    const icon_passenger_12_png = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png.scaleX = 0.35;
    icon_passenger_12_png.scaleY = 0.35;
    group2.add(icon_passenger_12_png);

    // icon_passenger_13_png
    const icon_passenger_13_png = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png.scaleX = 0.35;
    icon_passenger_13_png.scaleY = 0.35;
    group2.add(icon_passenger_13_png);

    // icon_passenger_14_png
    const icon_passenger_14_png = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png.scaleX = 0.35;
    icon_passenger_14_png.scaleY = 0.35;
    group2.add(icon_passenger_14_png);

    // icon_passenger_15_png
    const icon_passenger_15_png = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png.scaleX = 0.35;
    icon_passenger_15_png.scaleY = 0.35;
    group2.add(icon_passenger_15_png);

    // icon_passenger_16_png
    const icon_passenger_16_png = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png.scaleX = 0.35;
    icon_passenger_16_png.scaleY = 0.35;
    group2.add(icon_passenger_16_png);

    // icon_passenger_17_png
    const icon_passenger_17_png = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png.scaleX = 0.35;
    icon_passenger_17_png.scaleY = 0.35;
    group2.add(icon_passenger_17_png);

    // icon_passenger_18_png
    const icon_passenger_18_png = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png.scaleX = 0.35;
    icon_passenger_18_png.scaleY = 0.35;
    group2.add(icon_passenger_18_png);

    // icon_passenger_19_png
    const icon_passenger_19_png = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png.scaleX = 0.35;
    icon_passenger_19_png.scaleY = 0.35;
    group2.add(icon_passenger_19_png);

    // icon_passenger_2_png
    const icon_passenger_2_png = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png.scaleX = 0.35;
    icon_passenger_2_png.scaleY = 0.35;
    group2.add(icon_passenger_2_png);

    // icon_passenger_20_png
    const icon_passenger_20_png = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png.scaleX = 0.35;
    icon_passenger_20_png.scaleY = 0.35;
    group2.add(icon_passenger_20_png);

    // icon_passenger_3_png
    const icon_passenger_3_png = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png.scaleX = 0.35;
    icon_passenger_3_png.scaleY = 0.35;
    group2.add(icon_passenger_3_png);

    // icon_passenger_4_png
    const icon_passenger_4_png = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png.scaleX = 0.35;
    icon_passenger_4_png.scaleY = 0.35;
    group2.add(icon_passenger_4_png);

    // icon_passenger_5_png
    const icon_passenger_5_png = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png.scaleX = 0.35;
    icon_passenger_5_png.scaleY = 0.35;
    group2.add(icon_passenger_5_png);

    // icon_passenger_6_png
    const icon_passenger_6_png = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png.scaleX = 0.35;
    icon_passenger_6_png.scaleY = 0.35;
    group2.add(icon_passenger_6_png);

    // icon_passenger_7_png
    const icon_passenger_7_png = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png.scaleX = 0.35;
    icon_passenger_7_png.scaleY = 0.35;
    group2.add(icon_passenger_7_png);

    // icon_passenger_8_png
    const icon_passenger_8_png = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png.scaleX = 0.35;
    icon_passenger_8_png.scaleY = 0.35;
    group2.add(icon_passenger_8_png);

    // icon_passenger_9_png
    const icon_passenger_9_png = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png.scaleX = 0.35;
    icon_passenger_9_png.scaleY = 0.35;
    group2.add(icon_passenger_9_png);

    // group1
    const group1 = scene.add.container(-1138, -484);
    this.add(group1);

    // icon_passenger_1_png_5
    const icon_passenger_1_png_5 = scene.add.image(64, 65, "game-32", "icon-passenger-1.png");
    icon_passenger_1_png_5.scaleX = 0.35;
    icon_passenger_1_png_5.scaleY = 0.35;
    group1.add(icon_passenger_1_png_5);

    // icon_passenger_10_png_5
    const icon_passenger_10_png_5 = scene.add.image(180, 65, "game-32", "icon-passenger-10.png");
    icon_passenger_10_png_5.scaleX = 0.35;
    icon_passenger_10_png_5.scaleY = 0.35;
    group1.add(icon_passenger_10_png_5);

    // icon_passenger_11_png_5
    const icon_passenger_11_png_5 = scene.add.image(296, 65, "game-32", "icon-passenger-11.png");
    icon_passenger_11_png_5.scaleX = 0.35;
    icon_passenger_11_png_5.scaleY = 0.35;
    group1.add(icon_passenger_11_png_5);

    // icon_passenger_12_png_5
    const icon_passenger_12_png_5 = scene.add.image(64, 181, "game-32", "icon-passenger-12.png");
    icon_passenger_12_png_5.scaleX = 0.35;
    icon_passenger_12_png_5.scaleY = 0.35;
    group1.add(icon_passenger_12_png_5);

    // icon_passenger_13_png_5
    const icon_passenger_13_png_5 = scene.add.image(180, 181, "game-32", "icon-passenger-13.png");
    icon_passenger_13_png_5.scaleX = 0.35;
    icon_passenger_13_png_5.scaleY = 0.35;
    group1.add(icon_passenger_13_png_5);

    // icon_passenger_14_png_5
    const icon_passenger_14_png_5 = scene.add.image(412, 65, "game-32", "icon-passenger-14.png");
    icon_passenger_14_png_5.scaleX = 0.35;
    icon_passenger_14_png_5.scaleY = 0.35;
    group1.add(icon_passenger_14_png_5);

    // icon_passenger_15_png_5
    const icon_passenger_15_png_5 = scene.add.image(64, 297, "game-32", "icon-passenger-15.png");
    icon_passenger_15_png_5.scaleX = 0.35;
    icon_passenger_15_png_5.scaleY = 0.35;
    group1.add(icon_passenger_15_png_5);

    // icon_passenger_16_png_5
    const icon_passenger_16_png_5 = scene.add.image(180, 297, "game-32", "icon-passenger-16.png");
    icon_passenger_16_png_5.scaleX = 0.35;
    icon_passenger_16_png_5.scaleY = 0.35;
    group1.add(icon_passenger_16_png_5);

    // icon_passenger_17_png_5
    const icon_passenger_17_png_5 = scene.add.image(296, 181, "game-32", "icon-passenger-17.png");
    icon_passenger_17_png_5.scaleX = 0.35;
    icon_passenger_17_png_5.scaleY = 0.35;
    group1.add(icon_passenger_17_png_5);

    // icon_passenger_18_png_5
    const icon_passenger_18_png_5 = scene.add.image(64, 413, "game-32", "icon-passenger-18.png");
    icon_passenger_18_png_5.scaleX = 0.35;
    icon_passenger_18_png_5.scaleY = 0.35;
    group1.add(icon_passenger_18_png_5);

    // icon_passenger_19_png_5
    const icon_passenger_19_png_5 = scene.add.image(296, 297, "game-32", "icon-passenger-19.png");
    icon_passenger_19_png_5.scaleX = 0.35;
    icon_passenger_19_png_5.scaleY = 0.35;
    group1.add(icon_passenger_19_png_5);

    // icon_passenger_2_png_5
    const icon_passenger_2_png_5 = scene.add.image(528, 65, "game-32", "icon-passenger-2.png");
    icon_passenger_2_png_5.scaleX = 0.35;
    icon_passenger_2_png_5.scaleY = 0.35;
    group1.add(icon_passenger_2_png_5);

    // icon_passenger_20_png_5
    const icon_passenger_20_png_5 = scene.add.image(528, 413, "game-32", "icon-passenger-20.png");
    icon_passenger_20_png_5.scaleX = 0.35;
    icon_passenger_20_png_5.scaleY = 0.35;
    group1.add(icon_passenger_20_png_5);

    // icon_passenger_3_png_5
    const icon_passenger_3_png_5 = scene.add.image(180, 413, "game-32", "icon-passenger-3.png");
    icon_passenger_3_png_5.scaleX = 0.35;
    icon_passenger_3_png_5.scaleY = 0.35;
    group1.add(icon_passenger_3_png_5);

    // icon_passenger_4_png_5
    const icon_passenger_4_png_5 = scene.add.image(412, 181, "game-32", "icon-passenger-4.png");
    icon_passenger_4_png_5.scaleX = 0.35;
    icon_passenger_4_png_5.scaleY = 0.35;
    group1.add(icon_passenger_4_png_5);

    // icon_passenger_5_png_5
    const icon_passenger_5_png_5 = scene.add.image(412, 413, "game-32", "icon-passenger-5.png");
    icon_passenger_5_png_5.scaleX = 0.35;
    icon_passenger_5_png_5.scaleY = 0.35;
    group1.add(icon_passenger_5_png_5);

    // icon_passenger_6_png_5
    const icon_passenger_6_png_5 = scene.add.image(528, 181, "game-32", "icon-passenger-6.png");
    icon_passenger_6_png_5.scaleX = 0.35;
    icon_passenger_6_png_5.scaleY = 0.35;
    group1.add(icon_passenger_6_png_5);

    // icon_passenger_7_png_5
    const icon_passenger_7_png_5 = scene.add.image(412, 297, "game-32", "icon-passenger-7.png");
    icon_passenger_7_png_5.scaleX = 0.35;
    icon_passenger_7_png_5.scaleY = 0.35;
    group1.add(icon_passenger_7_png_5);

    // icon_passenger_8_png_5
    const icon_passenger_8_png_5 = scene.add.image(528, 297, "game-32", "icon-passenger-8.png");
    icon_passenger_8_png_5.scaleX = 0.35;
    icon_passenger_8_png_5.scaleY = 0.35;
    group1.add(icon_passenger_8_png_5);

    // icon_passenger_9_png_5
    const icon_passenger_9_png_5 = scene.add.image(296, 413, "game-32", "icon-passenger-9.png");
    icon_passenger_9_png_5.scaleX = 0.35;
    icon_passenger_9_png_5.scaleY = 0.35;
    group1.add(icon_passenger_9_png_5);

    // lists
    const groups = [group8, group7, group1, group3, group4, group6, group5, group2];

    this.groups = groups;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private groups: Phaser.GameObjects.Container[];

  /* START-USER-CODE */

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(1000, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public override show(onComplete?: (() => void) | undefined): void {
    this.transitionReset();
    this.transitionIn(onComplete);
  }

  public override hide(onComplete?: () => void) {
    this.transitionOut(onComplete);
  }

  protected transitionReset() {
    this.alpha = 0;
  }

  protected transitionIn(onComplete?: () => void) {
    for (const group of this.groups) {
      group.alpha = 0;
    }

    this.scene.add.tween({
      targets: this,
      alpha: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.add.tween({
      targets: this.groups,
      y: '-= 90',
      alpha: 1,
      duration: 1000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      onComplete: onComplete
    });

    // let itemDuration = 100;
    // let count = this.items.length - 1;
    // this.scene.add.tween({
    //   targets: this,
    //   x: this.x,
    //   duration: 25,
    //   repeat: this.items.length,
    //   onRepeat: () => {
    //     this.scene.add.tween({
    //       targets: this.items[count],
    //       y: '+=1000',
    //       duration: itemDuration,
    //       ease: Phaser.Math.Easing.Cubic.Out
    //     });
    //     count--;
    //   }
    // });
  }

  protected transitionOut(onComplete?: () => void) {
    this.coveredCallback?.();

    this.scene.add.tween({
      targets: this,
      alpha: 0,
      duration: 800,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 100,
      onComplete: onComplete
    });

    this.scene.add.tween({
      targets: this.groups,
      alpha: 0,
      duration: 800,
      ease: Phaser.Math.Easing.Quadratic.Out
    });

    // let itemDuration = 100;
    // let count = 0;
    // this.scene.add.tween({
    //   targets: this,
    //   x: this.x,
    //   duration: 25,
    //   repeat: this.items.length,
    //   onRepeat: () => {
    //     this.scene.add.tween({
    //       targets: this.items[count],
    //       y: '-=1000',
    //       duration: itemDuration,
    //       ease: Phaser.Math.Easing.Cubic.In
    //     });
    //     count++;
    //   }
    // });
  }

  protected startTransitionIdle(): void {}
  protected stopTransitionIdle(): void {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
